import { createPinia, PiniaVuePlugin } from 'pinia'
import Vue from 'vue'

const pinia = createPinia()
Vue.use(PiniaVuePlugin)

Vue.use(pinia as any)

export default pinia
